import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const UserDataGrpcContractProvider: Provider = {
  provide: MainApi.UserDataGrpcWebContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.UserDataGrpcWebContractClient, 'mainApi'),
};
